import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    step: {
        error: {
            redirectButtonText: string;
        };
    };
};

export const messagesES: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    step: {
        personalInfo: {
            howDoesVerifyingWorkDetails: 'A fin de cumplir con los requisitos para esta oferta, usted debe (1) ser profesional médico con licencia vigente y (2) ser miembro de una rama elegible de la profesión médica. Las ramas elegibles se muestran en el selector de status de este formulario.<br><br>{companyName} usa SheerID, un socio confiable, para verificar que usted es profesional médico. SheerID solo recopila información que permite verificar que usted cumple con los requisitos. Es posible que se solicite información o documentación adicional. ',
        },
        success: {
            verificationOnly: "SheerID solo maneja la verificación. Ahora que está aprobado, dirija todas las preguntas sobre los términos de promoción o el uso del código al servicio de atención al cliente de <a href='https://www.timberland.co.uk/customer-service/contact-us.html?geoRedirect=true' target=_blank class='sid-link' >Timberland/a>.",
        },
        error: {
            redirectButtonText: 'CONTINUAR TIMBERLAND',
        },
    },
};
